import { Link } from "@inertiajs/react"
import AppLayout from "@/components/AppLayout"
import PageTitle from "@/components/PageTitle"
import { formatMoney } from "@/lib/money"
import { purchase_products_path } from "@/lib/routes"
import Delta from "@/components/home/Delta"
import ListCard from "@/components/home/ListCard"
import MarketsTable from "./components/MarketsTable"
import MonthlyRevenueChart from "@/components/home/MonthlyRevenueChart"
import StatTile from "@/components/home/StatTile"
import { COMPANY, COMPANY_MONTHLY, MARKET_ROWS, PURCHASE_LIST } from "./data"

// Wireframe of the all-markets Dashboard (/dashboard). Mock data only.
export default function AllMarkets() {
  const cur = COMPANY.displayCurrency

  return (
    <AppLayout header={<PageTitle title="Dashboard" subtitle="How the company is doing, all markets" />}>
      <div className="flex max-w-6xl flex-col gap-4">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <StatTile label={`Revenue this month (${cur})`} value={formatMoney(COMPANY.revenueThisMonth, cur)}>
            <Delta pct={COMPANY.changePct} /> vs last month
          </StatTile>
          <StatTile label={`Revenue this year (${cur})`} value={formatMoney(COMPANY.revenueThisYear, cur)}>
            January to today
          </StatTile>
          <StatTile label="Products that need buying" value={COMPANY.needBuying} tone="warning">
            <Link href={purchase_products_path()} className="font-medium text-link underline-offset-4 hover:underline">
              Open Purchase Plan →
            </Link>
          </StatTile>
          <StatTile label="Products with excess stock" value={COMPANY.excess.total}>
            {COMPANY.excess.overstock} overstock · {COMPANY.excess.slow} slow · {COMPANY.excess.dead} dead
          </StatTile>
        </div>
        <div className="-mt-2 text-xs text-muted-foreground">
          Company revenue is converted to {cur} for display only. {COMPANY.rateLine}
        </div>

        <MarketsTable rows={MARKET_ROWS} />

        <div className="grid gap-4 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <MonthlyRevenueChart
              title="Revenue by month"
              subtitle={`All markets, in ${cur}`}
              currency={cur}
              data={COMPANY_MONTHLY}
              bars={[
                { key: "vietnam", name: "Vietnam", color: "var(--series-1)" },
                { key: "intl", name: "International", color: "color-mix(in srgb, var(--series-1) 55%, var(--card))" },
              ]}
            />
          </div>
          <ListCard
            title="Purchase list"
            rows={PURCHASE_LIST.map((r) => ({
              label: r.label,
              value: <span className={r.tone === "warning" ? "font-medium text-warning" : "font-medium"}>{r.value}</span>,
            }))}
            footer={{ label: "Open Purchase Plan", href: purchase_products_path() }}
          />
        </div>
      </div>
    </AppLayout>
  )
}
